export enum PatientActionTypes {
  GET_PATIENTS = "@@PATIENT/GET_PATIENTS",
  GET_PATIENTS_SUCCESS = "@@PATIENT/GET_PATIENTS_SUCCESS",
  GET_PATIENTS_FAILURE = "@@PATIENT/GET_PATIENTS_FAILURE",

  GET_PATIENT = "@@PATIENT/GET_PATIENT",
  GET_PATIENT_SUCCESS = "@@PATIENT/GET_PATIENT_SUCCESS",
  GET_PATIENT_FAILURE = "@@PATIENT/GET_PATIENT_FAILURE",

  GET_PATIENT_DETAILED_SENSORS_DATA = "@@PATIENT/GET_PATIENT_DETAILED_SENSORS_DATA",
  GET_PATIENT_DETAILED_SENSORS_DATA_SUCCESS = "@@PATIENT/GET_PATIENT_DETAILED_SENSORS_DATA_SUCCESS",
  GET_PATIENT_DETAILED_SENSORS_DATA_FAILURE = "@@PATIENT/GET_PATIENT_DETAILED_SENSORS_DATA_FAILURE",

  GET_PATIENT_SENSORS_AVERAGE_DATA = "@@PATIENT/GET_PATIENT_SENSORS_AVERAGE_DATA",
  GET_PATIENT_SENSORS_AVERAGE_DATA_SUCCESS = "@@PATIENT/GET_PATIENT_SENSORS_AVERAGE_DATA_SUCCESS",
  GET_PATIENT_SENSORS_AVERAGE_DATA_FAILURE = "@@PATIENT/GET_PATIENT_SENSORS_AVERAGE_DATA_FAILURE",

  GET_PATIENT_DAILY_ALERT_NOTIFICATIONS = "@@PATIENT/GET_PATIENT_DAILY_ALERT_NOTIFICATIONS",
  GET_PATIENT_DAILY_ALERT_NOTIFICATIONS_SUCCESS = "@@PATIENT/GET_PATIENT_DAILY_ALERT_NOTIFICATIONS_SUCCESS",
  GET_PATIENT_DAILY_ALERT_NOTIFICATIONS_FAILURE = "@@PATIENT/GET_PATIENT_DAILY_ALERT_NOTIFICATIONS_FAILURE",

  CREATE_PATIENT = "@@PATIENT/CREATE_PATIENT",
  CREATE_PATIENT_SUCCESS = "@@PATIENT/CREATE_PATIENT_SUCCESS",
  CREATE_PATIENT_FAILURE = "@@PATIENT/CREATE_PATIENT_FAILURE",

  IMPORT_PATIENTS = "@@PATIENT/IMPORT_PATIENTS",
  IMPORT_PATIENTS_SUCCESS = "@@PATIENT/IMPORT_PATIENTS_SUCCESS",
  IMPORT_PATIENTS_FAILURE = "@@PATIENT/IMPORT_PATIENTS_FAILURE",

  UPDATE_PATIENT = "@@PATIENT/UPDATE_PATIENT",
  UPDATE_PATIENT_SUCCESS = "@@PATIENT/UPDATE_PATIENT_SUCCESS",
  UPDATE_PATIENT_FAILURE = "@@PATIENT/UPDATE_PATIENT_FAILURE",

  UPDATE_PATIENT_STATUS = "@@PATIENT/UPDATE_PATIENT_STATUS",
  UPDATE_PATIENT_STATUS_SUCCESS = "@@PATIENT/UPDATE_PATIENT_STATUS_SUCCESS",
  UPDATE_PATIENT_STATUS_FAILURE = "@@PATIENT/UPDATE_PATIENT_STATUS_FAILURE",

  CLEAR_PATIENTS = "@@PATIENT/CLEAR_PATIENTS",
  CLEAR_PATIENT = "@@PATIENT/CLEAR_PATIENT",
  SET_FILTER = "@@PATIENT/SET_FILTER",
  UPDATE_FILTER = "@@PATIENT/UPDATE_FILTER",

  SET_DETAILED_CHART_FILTER = "@@PATIENT/SET_DETAILED_CHART_FILTER",
  SET_DAILY_CHART_FILTER = "@@PATIENT/SET_DAILY_CHART_FILTER",
}
